import React from 'react';
import './Amenities.css';

import * as white_assets from './assets/icons_white/index';


const shortToVerbose = {
  wheelchair_access: "Wheelchair Access",
  bathrooms: "Public Restrooms",
  cabanas: "Cabanas",
  sports: "Sports",
  swimming: "Swimming/Watersports",
  vendors: "Vendors",
  path: "Walking Path",
  playground: "Playground",
  dogs: "Dogs Allowed",
  dock: "Boat Ramp/Dock"
}

function Amenities(props) {

  return (
    <div style={{flexWrap: "wrap", display: "flex", justifyContent: "space-around"}}>
        {props.amenitiesList.map(function(amenity,index){
            return(
              <img title={shortToVerbose[amenity]}  key={amenity+index} className="icon-container" src={white_assets[amenity]}></img>
            )
        } )}
    </div>
  );
}

export default Amenities;
